module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDM2IDI2Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSkiPgogICAgPHBhdGggZD0iTS40MjUgMTIuNUwzMy42MTg1NjExIDEyLjVNLjQyNS41TDMzLjYxODU2MTEuNU0uNDI1IDI1LjVMMzMuNjE4NTYxMSAyNS41Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/img/menu-open.svg
// module id = 31
// module chunks = 20976610436329 34471704633725 89564116255167 135858987226052 162737523230842 258360696600495